// extracted by mini-css-extract-plugin
module.exports = {"Component":"OtpInput_Component__VWprD"};